/**
 * 项目类型的标准选项：这个项目的产品设计由谁负责。
 *
 * 新建项目向导和健康度明细（0930 就地补填）用同一份，别各写一份——
 * 模块中心那个自由文本框填出过「1」「不知填什么类型」这种值。
 */
export const PROJECT_TYPES = [
  { value: '自主设计', hint: '产品由我们负责设计' },
  { value: '非自主设计', hint: '按客户的设计生产' },
] as const;

export type ProjectTypeValue = (typeof PROJECT_TYPES)[number]['value'];
